// ═══════════════════════════════════════════════════════════════════════════════
//  src/pages/EntrevistaPage.jsx
//  INTERVIEW ROOM — ruta /entrevista
//
//  Orquestador de tres pantallas: formulario → sala → reporte.
//
//  MICROSERVICIO AISLADO. Todo lo suyo vive en `src/interview/` y habla sólo
//  con `/api/v3/interview`. No importa nada del tutor, del Dojo ni del
//  assessment; lo único que reutiliza es el Header de la app y la utilidad de
//  voz del navegador, que no pertenece a ningún módulo en particular.
//
//  Si mañana se decide apagar la sala de entrevistas, se borra esta página, la
//  carpeta `interview/`, una línea en App.jsx y un router en el backend. Nada
//  más se entera.
// ═══════════════════════════════════════════════════════════════════════════════

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Header from '../components/Header';
import usePageTracker from '../hooks/usePageTracker.js';

import InterviewSetup from '../interview/InterviewSetup';
import InterviewRunner from '../interview/InterviewRunner';
import InterviewReport from '../interview/InterviewReport';
import '../interview/interview.css';

export default function EntrevistaPage() {
  usePageTracker('entrevista', 'Interview Room', null, 'studying');

  const navigate = useNavigate();
  const [session, setSession] = useState(null);
  const [report, setReport] = useState(null);

  const toGym = () => navigate('/entrenar');

  const reset = () => {
    setSession(null);
    setReport(null);
  };

  return (
    <>
      <Header />
      <main className="iv-root">
        <div className="iv-shell">
          {report ? (
            <InterviewReport report={report} onAgain={reset} onExit={toGym} />
          ) : session ? (
            <InterviewRunner
              session={session}
              onFinished={(r) => { setReport(r); setSession(null); }}
              onExit={reset}
            />
          ) : (
            <InterviewSetup onStarted={setSession} onExit={toGym} />
          )}
        </div>
      </main>
    </>
  );
}
